export default function obtenerSubmodalidad(idSubmodalidad, submodalidades) {
    let submodalidad = "";
    try {
        for (let i = 0; i < submodalidades.length; i++) {
            if (Number(idSubmodalidad) === submodalidades[i].idSubmodalidad){
                submodalidad = submodalidades[i].nombreSubmodalidad.toUpperCase();
                break;
            } 
        }
    } catch (error) {
        console.log(error)
    }
    finally {
        return submodalidad;
    }

}